module.exports = __webpack_public_path__ + "static/media/landing-logo-seguro-cellular.5946d361.svg";